import { request } from "../../../backend";

/**
 * Logs into SaleSys using username and password authentication.
 * Authorization tokens are set as cookies.
 */
export async function loginUsernamePassword(username: string, password: string) {
  await request(
    '/login-v1', 'post', { username, password }, null, { api: 'users', injectStatus: true }
  );
}